// extracted by mini-css-extract-plugin
export var alignCenter = "_8j-d";
export var bannerShown = "_8j-6";
export var buttonContent = "_8j-0";
export var cardList = "_8j-1";
export var centerContent = "_8j-2";
export var chevron = "_8j-3";
export var closePanelButton = "_8j-k";
export var conversationContextContainer = "_8j-l";
export var conversationDetailContainer = "_8j-4";
export var detailWrapper = "_8j-7";
export var dropdownButton = "_8j-e";
export var dropdownTitle = "_8j-9";
export var fullHeight = "_8j-5";
export var hidden = "_8j-a";
export var icon = "_8j-b";
export var mergeSuggestionWrapper = "_8j-m";
export var panel = "_8j-i";
export var portalButtonsWrapper = "_8j-c";
export var right = "_8j-j";
export var tableSummaryContainer = "_8j-8";
export var tableSummaryHeader = "_8j-g";
export var threeDotsButton = "_8j-f";
export var wide = "_8j-h";